import request from '@/utils/request'

/**
 * 获取小区列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function getCommunityList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityManage/list',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存小区信息
 * @param {Object} data 小区数据
 * @returns {Promise} Promise对象
 */
export function saveCommunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityManage/save',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新小区信息
 * @param {Object} data 小区数据
 * @returns {Promise} Promise对象
 */
export function updateCommunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityManage/update',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除小区
 * @param {Object} data 删除参数
 * @returns {Promise} Promise对象
 */
export function deleteCommunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityManage/delete',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 撤回审核
 * @param {Object} data 撤回参数
 * @returns {Promise} Promise对象
 */
export function recallAudit(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityManage/recall',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取区域数据
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function getAreas(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityManage/getAreas',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取属性规格
 * @param {String} specType 规格类型
 * @returns {Promise} Promise对象
 */
export function getAttrSpec(specType) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityManage/getAttrSpec',
      method: 'get',
      params: { specType }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取属性值
 * @param {String} specCd 规格编码
 * @returns {Promise} Promise对象
 */
export function getAttrValue(specCd) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityManage/getAttrValue',
      method: 'get',
      params: { specCd }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取字典数据
 * @param {String} dictType 字典类型
 * @param {String} state 状态
 * @returns {Promise} Promise对象
 */
export function getDict(dictType, state) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityManage/getDict',
      method: 'get',
      params: { dictType, state }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取当前店铺ID
 * @returns {Promise} Promise对象
 */
export function getShopId() {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityManage/getShopId',
      method: 'get'
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}